import { NgModule } from '@angular/core';
import { Routes, RouterModule } from "@angular/router"

import { PageSearchComponent } from "./page-search/page-search.component"

const appRoutes: Routes = [
	{ path: "", component: PageSearchComponent },
	{
		path: "manager",
		loadChildren: async () => (await import("./manager/manager.module")).ManagerModule
	},
	{
		path: '*',
		redirectTo:""
	},
]

@NgModule({
	imports: [RouterModule.forRoot(appRoutes)],
	exports: [RouterModule]
})

export class AppRoutingModule {

}